import React, { FC, useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router";

import { PaperClipOutlined, PlusOutlined, SmileOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { TablePaginationConfig } from "antd/lib/table/interface";
import { isEmpty } from "lodash-es";

import { CreateOrderDevTool } from "devtools/CreateOrderDevTool";
import { getSortDirection } from "helperFunctions/_common/getSortDirection";

import { fetchOrderIndex, FetchOrderIndexQueryOption } from "../../../../../api/fulfillment/order";
import { getOrderBaseColumns } from "../../../../../components/fulfillment/order/OrdersTable/helpers";
import Table from "../Table";
export interface Sorter {
  field: string;
  order: "ascend" | "descend";
}
interface OrdersTableProps {
  query: FetchOrderIndexQueryOption;
}

const OrdersTable: FC<OrdersTableProps> = ({ query }) => {
  const history = useHistory();
  const organizationID = query.organization_id;
  const [sort, setSort] = useState({ field: "created_at", direction: "" });

  const orderIndex = useQuery(
    ["orderIndex", query, sort],
    () =>
      fetchOrderIndex({
        ...query,
        ...(sort.direction && sort.field && sort),
      }),
    {
      enabled: !isEmpty(query),
    }
  );
  const [createOrderDevToolVisible, setCreateOrderDevToolVisible] = useState(false);

  const goToCreateOrderPage = () => {
    history.push(`/organizations/${organizationID}/orders/create`);
  };

  const goToCreateOrderCSVPage = () => {
    history.push(`/organizations/${organizationID}/orders/create-via-csv`);
  };

  const handleTableChange = (sorter: Sorter) => {
    const { field, order } = sorter;
    setSort({ field: field, direction: getSortDirection(order) });
  };

  const title = "Orders";
  const fullOrdersLink = `/organizations/${organizationID}/orders`;
  const columns = getOrderBaseColumns();
  const tableProps = {
    columns,
    dataSource: orderIndex.data?.data,
    loading: orderIndex.isLoading,
    onChange: (pagination: TablePaginationConfig, filters: Record<string, React.ReactText[] | null>, sort: Sorter) =>
      handleTableChange(sort),
  };
  const getHeaderButtons = () => {
    const headerButtons = [
      <Button
        key="return"
        style={{ marginLeft: "10px" }}
        onClick={() => history.push(fullOrdersLink)}
        icon={<PlusOutlined />}
      >
        Create Return Shipment
      </Button>,
      <Button key="create-order" style={{ marginLeft: "10px" }} onClick={goToCreateOrderPage} icon={<PlusOutlined />}>
        Create Order
      </Button>,
      <Button
        key="create-order-via-csv"
        style={{ marginLeft: "10px" }}
        onClick={goToCreateOrderCSVPage}
        icon={<PaperClipOutlined />}
      >
        Create Order Via CSV
      </Button>,
    ];

    const createOrderDevToolButton = (
      <Button key="createOrderDevTool" onClick={() => setCreateOrderDevToolVisible(true)} icon={<SmileOutlined />}>
        Create Order Dev Tool
      </Button>
    );
    const isStaging = process.env.REACT_APP_ENV === "staging";

    if (isStaging) headerButtons.unshift(createOrderDevToolButton);

    return headerButtons;
  };

  return (
    <div className="fulfillment-table">
      <Table
        headerButtons={organizationID ? getHeaderButtons() : null}
        tableProps={tableProps}
        title={title}
        fullListLink={fullOrdersLink}
      />
      {organizationID && (
        <CreateOrderDevTool
          visible={createOrderDevToolVisible}
          organizationID={organizationID}
          setVisible={setCreateOrderDevToolVisible}
        />
      )}
    </div>
  );
};

export default OrdersTable;
